import React from "react";
import Icon from "components/AppIcon";
import Button from "components/ui/Button";

/**
 * Phase 10 — dashboards without a backend endpoint render this instead of
 * fabricated analytics. Shows why + a retry option.
 */
export default function DataUnavailable({ feature, onRetry }) {
  return (
    <div
      className="flex flex-col items-center justify-center gap-3 rounded-xl border px-6 py-10 text-center"
      style={{ borderColor: "var(--color-border)", background: "var(--color-card)" }}
    >
      <div
        className="flex items-center justify-center w-12 h-12 rounded-full"
        style={{ background: "var(--color-muted)" }}
      >
        <Icon name="Database" size={20} color="var(--color-text-secondary)" />
      </div>
      <div>
        <p className="font-caption text-sm font-semibold" style={{ color: "var(--color-foreground)" }}>
          {feature} — data unavailable
        </p>
        <p className="font-caption text-sm mt-1" style={{ color: "var(--color-text-secondary)" }}>
          This dashboard is not backed by a backend API yet, so no data is shown.
        </p>
      </div>
      {onRetry && (
        <Button variant="outline" size="sm" iconName="RotateCcw" iconPosition="left" iconSize={14} onClick={onRetry}>
          Retry
        </Button>
      )}
    </div>
  );
}
